import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Collapse } from "react-bootstrap";

export default function MyCollapse({
  heading,
  children,
  defaultShow = false,
  title,
  headingActions,
  actions,
  show,
  onShowChange,
  headerProps = {},
  disabled = false,
}) {
  const [internalShow, setInternalShow] = useState(defaultShow);
  const isControlled = show !== undefined;
  const isShown = isControlled ? show : internalShow;
  const setShown = (value) => {
    if (!isControlled) {
      setInternalShow(value);
    }
    onShowChange?.(value);
  };

  return (
    <div className="w-100">
      <div className="d-flex align-items-center w-100" {...headerProps}>
        <button
          type="button"
          title={title}
          disabled={disabled}
          className="btn p-0 border-0 shadow-none text-start text-nowrap overflow-hidden"
          onClick={() => {
            if (disabled) return;
            setShown(!isShown);
          }}
        >
          <div className="d-flex align-items-center">
            {heading}
            {!disabled ? (
              <span className="p-1 px-2 ms-2 rounded-2 text-purple d-inline-block">
                {isShown ? (
                  <FontAwesomeIcon icon={faAngleUp} />
                ) : (
                  <FontAwesomeIcon icon={faAngleDown} />
                )}
              </span>
            ) : null}
          </div>
        </button>
        {headingActions}
        {actions}
      </div>
      <Collapse in={isShown} mountOnEnter unmountOnExit>
        <div>{children}</div>
      </Collapse>
    </div>
  );
}
